import { PrimaryLinkCTA, SecondaryLinkCTA } from "../../../../src/components/ctas/cta";
import * as React from 'react';
export default {
  PrimaryLinkCTA,
  SecondaryLinkCTA,
  React
};